// @core/api/endpoints/workflow/update_schedule.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PipelineScheduleResponse,
  UpdateScheduleRequest,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Update schedule
 * Updates a pipeline schedule's cron expression, interval, timezone, or active status.
 */
export async function UpdateSchedule(
  schedule_id: string,
  data: UpdateScheduleRequest,
  options?: RequestOptions
): Promise<PipelineScheduleResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/schedules/:schedule_id`;
  requestPath = requestPath.replace(':schedule_id', encodeURIComponent(schedule_id));
  const requestOptions = options;
  return client.put<PipelineScheduleResponse>(requestPath, data, requestOptions);
}
